module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter registration cover"
  }, [_c('div', {
    staticClass: "enter__outer"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "enter__inner"
  }, [_c('form', {
    staticClass: "enter-form registration__form",
    attrs: {
      "id": "entry_form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendSMS($event)
      }
    }
  }, [_c('input-phone', {
    attrs: {
      "user": _vm.user,
      "placeholder": 'Введите номер телефона',
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "enter-form__button",
    attrs: {
      "type": "submit",
      "value": "Получить SMS"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/login'
    }
  }, [_c('a', {
    staticClass: "enter-form__link"
  }, [_vm._v("Я уже зарегистрирован")])]), _vm._v(" "), _c('p', {
    staticClass: "enter__text"
  }, [_vm._v("Шаг 1 из 4")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enter__inner registration__enter-inner"
  }, [_c('div', {
    staticClass: "main-logo registration__logo"
  }, [_c('img', {
    staticClass: "main-logo__item",
    attrs: {
      "src": require("../../../assets/img/logo.png"),
      "alt": "logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-349aa76a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/Register/One.vue
// module id = 602
// module chunks = 0